import React from 'react';

import Layout from 'layouts/Layout';
import Terms from './Terms';

const DaysOffLayout = ({ match }) => <Layout component={Terms} match={match} />;

export default DaysOffLayout;
